import React, {useEffect, useRef, useState} from 'react';
import {ArrowRight, Check, Clock3, RotateCcw} from 'lucide-react';
import './study-agenda.css';

const days=['Terça','Quarta','Quinta'];
const blocks=[
  {id:'preventiva',area:'Medicina Preventiva',topic:'Imunização',format:'Revisão concluída',col:0,row:0,kind:'done'},
  {id:'pediatria',area:'Pediatria',topic:'Desidratação',format:'Revisar os erros',col:0,row:1,kind:'review'},
  {id:'clinica',area:'Clínica Médica',topic:'Insuficiência cardíaca',format:'Resolver questões',col:1,row:0,kind:'practice'},
  {id:'go',area:'Ginecologia e Obstetrícia',topic:'Pré-natal',format:'Resumo + questões',col:2,row:1,kind:'next'},
];
const messages={
  planned:['Uma mudança no dia. Um ajuste no plano.','Experimente o botão e acompanhe a revisão mudando de lugar.'],
  moving:['Reorganizando, sem pular a revisão.','Pediatria vai para quarta. Clínica Médica passa para quinta.'],
  adjusted:['A revisão continua sendo prioridade.','O conteúdo foi remanejado. Nenhum assunto saiu do plano.'],
};

export function StudyAgenda({quiet}) {
  const [phase,setPhase]=useState('planned');
  const timers=useRef([]);
  const adjusted=phase!=='planned';
  const cancelTimers=()=>{timers.current.forEach(clearTimeout);timers.current=[];};
  useEffect(()=>()=>timers.current.forEach(clearTimeout),[]);
  function demonstrate() {
    cancelTimers();
    const start=()=>{
      setPhase('moving');
      timers.current.push(setTimeout(()=>setPhase('adjusted'),quiet?150:1250));
    };
    if(adjusted){
      setPhase('planned');
      timers.current.push(setTimeout(start,quiet?150:650));
    }else start();
  }
  function reset(){cancelTimers();setPhase('planned');}
  return <div className="a-calendar" data-phase={phase} data-quiet={quiet}>
    <header className="a-cal-header">
      <div className="a-cal-brand"><img src="assets/Enamed2.png" width="853" height="240" alt="A Mentoria ENAMED"/><span>Sua semana de estudos</span></div>
      <div className="a-cal-controls">
        <button className="a-cal-adjust" type="button" onClick={demonstrate} disabled={phase==='moving'}><Clock3 aria-hidden="true"/>{phase==='moving'?'Ajustando…':adjusted?'Rever ajuste':'Tenho menos tempo'}</button>
        <button className="a-cal-reset" type="button" onClick={reset} aria-label="Restaurar a semana original"><RotateCcw aria-hidden="true"/></button>
      </div>
    </header>
    <div className="a-cal-schedule">
      <div className="a-cal-days" aria-hidden="true">{days.map((day,index)=><div key={day}><span>{day}</span>{index===0&&<small>Hoje</small>}</div>)}</div>
      <div className="a-cal-board" role="list" aria-label="Exemplo de semana de estudos">
        <div className="a-cal-grid" aria-hidden="true"><span/><span/><span/></div>
        <span className="a-cal-freed" aria-hidden="true">{adjusted?'Seu tempo, respeitado.':''}</span>
        {blocks.map(block=>{
          const moved=adjusted&&(block.id==='pediatria'||block.id==='clinica');
          const col=moved?block.col+1:block.col;
          const row=moved?0:block.row;
          return <div role="listitem" className={'a-cal-block a-cal-'+block.kind} key={block.id} style={{'--day':col,'--slot':row}} data-moved={moved} aria-label={days[col]+': '+block.area+', '+block.topic+'. '+block.format}>
            <div className="a-cal-tile">
              <span className="a-cal-area">{block.area}</span>
              <strong>{block.topic}</strong>
              <span className="a-cal-format">{block.kind==='done'?<Check aria-hidden="true"/>:block.kind==='review'?<RotateCcw aria-hidden="true"/>:null}{block.format}</span>
            </div>
          </div>;
        })}
      </div>
    </div>
    <div className="a-cal-caption" role="status" aria-atomic="true">
      <span className="a-cal-status-icon" aria-hidden="true">{phase==='adjusted'?<Check/>:<ArrowRight/>}</span>
      <p><strong>{messages[phase][0]}</strong><span>{messages[phase][1]}</span></p>
    </div>
    <p className="a-cal-disclaimer">Demonstração ilustrativa. O plano individual considera sua rotina e suas dificuldades.</p>
  </div>;
}
